/**
 * Created by Jie Gao on 2017-06-16.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {
    INearWinReelDividerConfig,
    NearWinReelDivider
} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {WixxParsedGameData} from "../server/data/WixxParsedGameData";
import {WixxSoundConfig} from "../WixxSoundConfig";

export class WixxNearWinReelDivider extends NearWinReelDivider {

    private _nearWinReels:boolean[];
    private _singleWin:number;

    constructor(config:INearWinReelDividerConfig) {
        super(config);
        this._nearWinReels = [];
        this._singleWin = -1;
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinReelEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event:GameEvent) => this.onReelBounce(event.params[0]));
    };

    private onGameDataParsed(data:WixxParsedGameData):void {
        this._nearWinReels = data.nearWinReels;
        this._singleWin = data.singleWin;
    }

    protected createNearWinDivider(index:number):TimelineSprite | null {
        const sprite:TimelineSprite | null = super.createNearWinDivider(index);

        if(!sprite) {
            debugger;
            throw new Error("Error:WinxxNearWinReelDividers.createNearWinDivider()");
        }

        sprite.scale.set(2, 2);
        return sprite;
    }

    private onReelBounce(data:IReelStoppedData):void {
        if(this.hasFail(data.reelId)) {
            if(WixxSoundConfig.instance.REEL_NEAR_WIN_FAIL != null) {
                SlotGame.sound.playEffect(WixxSoundConfig.instance.REEL_NEAR_WIN_FAIL);
            }
        }
    }

    private hasFail(reelId:number):boolean {
        //never play fail sound on 4th reel since if we have nearwin on 4th reel, there must be a win.
        if(!this._nearWinReels[0] || reelId === 4 || this._singleWin > 0) {
            return false;
        }

        if(this._nearWinReels[reelId] && !this._nearWinReels[reelId + 1]) {
            return true
        }

        return false;
    }
}